import { apiLimit } from './api-limit'
import { manage } from './manage'
import { members } from './members'
import { notificationSettings } from './notification-settings'
import { profile } from './profile'
import { systemIds } from './systemIds'
import { token } from './token'

export const organization = {
  profile,
  systemIds,
  manage,
  members,
  token,
  apiLimit,
  notificationSettings,
}
